import React from 'react';
import { Alert } from 'antd';
import NameField from '../../components/NameField';
import DescriptionField from '../../components/DescriptionField';
import AvailableToClientField from '../../components/AvailableToClient';
import PeriodField from '../../components/PeriodFields';
import UploadField from '../../components/UploadField';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import SelectOwner from '../../components/SelectOwner';
import styles from '../../index.module.scss';

const FormComponent = ({ submitStateMessage }) => {
  const clientId = useModalWatch({
    name: modalNames.attachmentsForm,
    selector: (state) => {
      return state?.props?.record?.client?.id;
    },
  });

  return (
    <>
      {Boolean(submitStateMessage) && (
        <Alert message={submitStateMessage} type="error" />
      )}
      <div className={styles.nameDescriptionWrapper}>
        <NameField />
        <DescriptionField />
        <AvailableToClientField />
      </div>
      <PeriodField />
      {!clientId && <SelectOwner />}
      <UploadField label="Вложение" multiple={false} />
    </>
  );
};

export default FormComponent;
